import Repo from './Repo.js'

export default class RecordBookRepository extends Repo {
  constructor () {
    super('record-books')
  }

  all (q) {
    return super.all(q)
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, { include })
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (data) {
    return this.http.post(this.resource + '/search', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  deletedPaginate (data, include) {
    if(include){
      data.include = include;
    }
    return this.http.get(this.resource + '/paginate/deleted', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  getDeleted (id, include) {
    return this.http.get(this.resource + '/' + id +'/deleted', { include }).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  deletedRestore (id) {
    return this.http.get(this.resource + '/' + id + '/restore').then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  deletedDelete (id) {
    return this.http.delete(this.resource + '/' + id + '/force').then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  uploadFile (data) {
    return this.http.post('record-book-files', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  removeFile (id) {
    return this.http.delete('record-book-files/' + id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }
}
